import HTMLTemplate from './template.html'
import './styles.scss'

export const CityPoupComponent = (() => {
    var vueComponent = {
        data() {
            return {
                port:'',
                city: '',
                country: '',
                leftPosition: 0,
                topPosition: 0,
                display: 'none',
                opacity: 0,
                cityRating: 0,
                countryRating: 0,
                isPort: false
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-city-popup')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();

